import * as React from 'react';
import clsx from 'classnames';

function SvgOpenedEye({className, ...props}) {
    return (
        <svg width={16} height={16} fill="none" className={clsx('text-font-tertiary', className)} {...props}>
            <g opacity={0.7} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13.93 7.766a.359.359 0 010 .468c-.467.562-1.293 1.462-2.342 2.218-1.055.76-2.29 1.34-3.588 1.34-1.296 0-2.532-.58-3.587-1.34-1.05-.756-1.875-1.656-2.342-2.218a.359.359 0 010-.468c.467-.562 1.293-1.462 2.342-2.218 1.055-.76 2.29-1.34 3.587-1.34 1.297 0 2.533.58 3.588 1.34 1.05.756 1.875 1.656 2.342 2.218z" />
                <circle cx={8} cy={8} r={1.5} fill="currentColor" />
            </g>
        </svg>
    );
}

export default SvgOpenedEye;
